<template>
    <div class="users-style">

        <div class="custom-loader-wrapper" v-if="download_loader">
            <div class="text-center">
                <div class="d-flex justify-content-center">
                    <span class="max-450 text-center">
                        {{ download_text }}
                    </span>
                </div>
                <img v-bind:src="$api_url + '/images/download-loader.svg'" class="loader-logo" width="100px" />
                <p class="mt-5">Plesae click <a target="_blank" :href="$api_url + '/company/dashboard'">here</a> or
                    below
                    if you want to continue surfing the system.</p>
                <b-button class="mb-1" target="_blank" :href="$api_url + '/company/dashboard'">Dashboard</b-button>

            </div>
        </div>


        <div class="row">
            <!--
             <div class="col-md-10 col-sm-12" >
                <h4 class="atlhr-dashboard-title mt-10">Documents
                    <span><a v-bind:href="$api_url+'/company/dashboard'">Dashboard </a>/ Core HR / Certificates </span>
                </h4>
            </div>
        -->

        </div>

        <div class="row">
            <div class="col-md-10 col-sm-12" v-if="selected.length == 1">
                <span>Selected No of Employee: </span><span>{{ selected.length }}</span>

            </div>
            <div class="col-md-10 col-sm-12" v-if="selected.length > 1">
                <span>Selected No of Employees: </span><span>{{ selected.length }}</span>

            </div>

        </div>

        <!--
        <div class="row">
            <div class="col-md-10 col-sm-12" v-for="document in documents" v-if="document.value == modification_flag">
                <span>Selected Document: </span><span >{{document.text}}</span>

            </div>
        </div>
        -->


        <div class="card mt-0 border-0 no-shadow"> <!-- Mustafijur Removed: bg-wash on 09-04-2026 -->
            <div class="card-header px-0 bg-transparent border-0">
                <div class="row no-margin employee-btn-holder trz_ppl_wrapper_2">
                    <template v-if="$acl['templates/list'] > 1">
                        <div class="ml-1">

                            <b-dropdown :text="dropdown_text" class="trz-custom-dropdown" style="width:100%">
                                <b-dropdown-divider></b-dropdown-divider>
                                <b-dropdown-group id="dropdown-group-1" header="Contracts">
                                    <b-dropdown-item @click="setModificationFlag(11)">
                                        <span class="d-flex align-items-center">
                                            <b-icon icon="receipt" class="mr-2" scale="1"></b-icon>Employment Contract
                                        </span>
                                    </b-dropdown-item>
                                    <b-dropdown-item @click="setModificationFlag(12)">
                                        <span class="d-flex align-items-center">
                                            <b-icon icon="receipt" class="mr-2" scale="1"></b-icon>Contract Change
                                            Letter
                                        </span>
                                    </b-dropdown-item>
                                </b-dropdown-group>

                                <b-dropdown-divider></b-dropdown-divider>
                                <b-dropdown-group id="dropdown-group-1" header="HR Certificates">
                                    <b-dropdown-item @click="setModificationFlag(3)">
                                        <span class="d-flex align-items-center">
                                            <b-icon icon="receipt" class="mr-2" scale="1"></b-icon>Letter of
                                            Introduction
                                        </span>
                                    </b-dropdown-item>
                                    <b-dropdown-item @click="setModificationFlag(4)">
                                        <span class="d-flex align-items-center">
                                            <b-icon icon="receipt" class="mr-2" scale="1"></b-icon>Increment Letter
                                        </span>
                                    </b-dropdown-item>
                                    <b-dropdown-item @click="setModificationFlag(9)">
                                        <span class="d-flex align-items-center">
                                            <b-icon icon="receipt" class="mr-2" scale="1"></b-icon>Standard Salary
                                            Certificate (Current Salary)
                                        </span>
                                    </b-dropdown-item>
                                    <b-dropdown-item @click="setModificationFlag(10)">
                                        <span class="d-flex align-items-center">
                                            <b-icon icon="receipt" class="mr-2" scale="1"></b-icon>Standard Salary
                                            Certificate (Period Range)
                                        </span>
                                    </b-dropdown-item>
                                </b-dropdown-group>

                                <b-dropdown-divider></b-dropdown-divider>
                                <b-dropdown-group id="dropdown-group-1" header="Compliance Certificates">
                                    <b-dropdown-item @click="setModificationFlag(1)">
                                        <span class="d-flex align-items-center">
                                            <b-icon icon="receipt" class="mr-2" scale="1"></b-icon>Income Tax Deduction
                                            Certificate
                                        </span>
                                    </b-dropdown-item>
                                    <b-dropdown-item @click="setModificationFlag(2)">
                                        <span class="d-flex align-items-center">
                                            <b-icon icon="receipt" class="mr-2" scale="1"></b-icon>Investment
                                            Declaration Letter
                                        </span>
                                    </b-dropdown-item>
                                </b-dropdown-group>

                                <b-dropdown-divider></b-dropdown-divider>
                                <b-dropdown-group id="dropdown-group-1" header="Leaver Certificates">
                                    <b-dropdown-item @click="setModificationFlag(8)">
                                        <span class="d-flex align-items-center">
                                            <b-icon icon="receipt" class="mr-2" scale="1"></b-icon>Release Letter
                                        </span>
                                    </b-dropdown-item>
                                    <b-dropdown-item @click="setModificationFlag(5)">
                                        <span class="d-flex align-items-center">
                                            <b-icon icon="receipt" class="mr-2" scale="1"></b-icon>Experience
                                            Certificate
                                        </span>
                                    </b-dropdown-item>
                                    <b-dropdown-item @click="setModificationFlag(16)">
                                        <span class="d-flex align-items-center">
                                            <b-icon icon="receipt" class="mr-2" scale="1"></b-icon>Letter of
                                            Recommendation
                                        </span>
                                    </b-dropdown-item>
                                    <!-- Afrin: Added for Template sub-category start -->
                                    <b-dropdown-item  @click="setModificationFlag(1001)" ><b-icon icon="receipt" class="mr-2" scale="1"></b-icon>Acceptance of Resignation</b-dropdown-item>
                                    <b-dropdown-item  @click="setModificationFlag(1002)" ><b-icon icon="receipt" class="mr-2" scale="1"></b-icon>Termination Letter</b-dropdown-item>
                                    <!-- Afrin: Added for Template sub-category end -->
                                </b-dropdown-group>
                            </b-dropdown>
                        </div>

                        <!-- Faroque code starts here -->

                        <div class="ml-1" v-if="((modification_flag > 2))">
                            <div class="employee-btn-holder">
                                <b-button class="mb-1" @click="downloadCertificate(1, 1)">Save to Employee
                                    Profile</b-button>

                            </div>
                        </div>

                        <!-- Faroque code ends here -->

                        <div class="ml-1" v-if="modification_flag != 0">
                            <b-dropdown text="Downloads" class="trz-custom-dropdown mb-1" style="width:100%">
                                <!-- Modified by Faroque -->

                                <b-dropdown-group id="dropdown-group-1" v-if="((modification_flag > 2))">
                                    <b-dropdown-item @click="downloadCertificate(1, 0)"><b-icon icon="box-arrow-in-down"
                                            class="mr-2" scale="1"></b-icon>Save to Employee
                                        Profile and Download Selected</b-dropdown-item>
                                    <b-dropdown-item @click="downloadAllCertificate(1, 0)"><b-icon
                                            icon="box-arrow-in-down" class="mr-2" scale="1"></b-icon>Save to Employee
                                        Profile and Download All</b-dropdown-item>

                                    <b-dropdown-item @click="downloadCertificate(0, 0)"><b-icon icon="box-arrow-in-down"
                                            class="mr-2" scale="1"></b-icon>Download
                                        Selected</b-dropdown-item>
                                    <b-dropdown-item @click="downloadAllCertificate(0, 0)"><b-icon
                                            icon="box-arrow-in-down" class="mr-2" scale="1"></b-icon>Download
                                        All</b-dropdown-item>
                                </b-dropdown-group>
                                <b-dropdown-group id="dropdown-group-1" v-else>
                                    <b-dropdown-item @click="downloadCertificate(0, 0)"><b-icon icon="box-arrow-in-down"
                                            class="mr-2" scale="1"></b-icon>Download
                                        Selected</b-dropdown-item>
                                    <b-dropdown-item @click="downloadAllCertificate(0, 0)"><b-icon
                                            icon="box-arrow-in-down" class="mr-2" scale="1"></b-icon>Download
                                        All</b-dropdown-item>
                                </b-dropdown-group>
                            </b-dropdown>
                        </div>

                        <div class="ml-1" v-if="modification_flag != 0">

                            <b-dropdown text="Email" class="trz-custom-dropdown mb-1" style="width:100%">
                                <!-- Modified by Faroque -->

                                <b-dropdown-group id="dropdown-group-1" v-if="((modification_flag > 2))">
                                    <!-- alpha fix chnaged icone of all 3 here  -->
                                    <b-dropdown-item @click="sendEmail(1)">
                                        <span class="d-flex align-items-center">
                                            <b-icon icon="envelope" class="mr-2"></b-icon>Save to Employee Profile and
                                            Email
                                        </span>
                                    </b-dropdown-item>
                                    <b-dropdown-item @click="sendEmail(0)">
                                        <span class="d-flex align-items-center">
                                            <b-icon icon="envelope" class="mr-2"></b-icon>Email
                                        </span>
                                    </b-dropdown-item>
                                </b-dropdown-group>
                                <!-- alpha fix chnaged icone here  -->
                                <b-dropdown-group id="dropdown-group-1" v-else>
                                    <b-dropdown-item @click="sendEmail(0)">
                                        <span class="d-flex align-items-center">
                                            <b-icon icon="envelope" class="mr-2"></b-icon>Email
                                        </span>
                                    </b-dropdown-item>
                                </b-dropdown-group>
                            </b-dropdown>

                        </div>


                        <div class="ml-1" v-if="modification_flag == 1 || modification_flag == 2">

                            <b-form-select id="fiscal_year" name="fiscal_year" v-model="fiscal_year"
                                :options="fiscal_years"></b-form-select>
                        </div>

                        <div class="ml-1" v-if="modification_flag == 10">
                            <span class="">Fiscal Year : </span>
                            <b-form-select style="width:auto;" id="from_fiscal_year" name="from_fiscal_year"
                                v-model="from_fiscal_year" :options="fiscal_years_salary"
                                @change="generateMonth(from_fiscal_year)"></b-form-select>

                        </div>
                        <div class="ml-1" v-if="modification_flag == 10">
                            <span class="">From : </span>
                            <b-form-select style="width:auto;" id="from_month" name="from_month" v-model="from_month"
                                :options="from_month_array"></b-form-select>
                        </div>

                        <!-- <div class="ml-1" v-if="modification_flag ==10">

                        <b-form-select style="width:auto;" id="to_fiscal_year" name="to_fiscal_year" v-model="to_fiscal_year" :options="fiscal_years_salary"></b-form-select>
                    </div> -->
                        <div class="ml-1" v-if="modification_flag == 10">
                            <span class="">To : </span>
                            <b-form-select style="width:auto;min-width: 155px;" id="to_month" name="to_month"
                                v-model="to_month" :options="to_month_array_final"></b-form-select>
                        </div>

                        <div class="ml-1" v-if="modification_flag == 9">
                            <b-form-select id="salary_month" name="salary_month" v-model="salary_month"
                                :options="month_array"></b-form-select>
                        </div>
                    </template>
                </div>
            </div>
            {{ regenerateMonths }}
            {{ sendFiscalYear }}


            <div v-if="emailing != ''" class="alert alert-info" role="alert"><img
                    :src="this.$api_url + '/images/loading.gif'" width="20" class="mr-2"> We are initiating email
                sending
                process. Please wait, this may take few seconds...
            </div>
            <div v-if="emailing_success != ''" class="alert alert-success" role="alert"><b-icon icon="check-circle-fill"
                    class="mr-2" variant="success"></b-icon> {{ emailing_success }} </div>
            <div v-if="emailing_issue != ''" class="alert alert-warning" role="alert"><b-icon
                    icon="exclamation-circle-fill" class="mr-2" variant="warning"></b-icon> {{ emailing_issue }} </div>
            <b-overlay :show="showoverlay" rounded="sm" class='core_hr_certificate_list_overlay'>
                <common-list :checkbox="checkbox" :is_action="is_action" :key="list_key"
                    :appended_column="appended_column" :company_options="company_options" :employees="employees"
                    :default_column="default_column" :primary_key="primary_key"
                    :common_list_fiscal_year="common_list_fiscal_year" all_employee='yes'
                    v-on:childToParent="listReturn"></common-list>
            </b-overlay>
        </div>

    </div>
</template>

<script>
export default
    {
        data() {
            const now = new Date()
            const today = new Date(now.getFullYear(), now.getMonth(), now.getDate())
            const currMonth = now.getMonth();

            var m_names = ['January', 'February', 'March',
                'April', 'May', 'June', 'July',
                'August', 'September', 'October', 'November', 'December'];


            const fullText2 = m_names[currMonth] + '-' + now.getFullYear();

            return {

                common_list_fiscal_year: '',
                fiscal_year: '',
                to_fiscal_year: '',
                from_fiscal_year: '',
                fiscal_years_salary: [],
                fiscal_years: [],

                salary_month: fullText2,
                to_month: fullText2,
                from_month: fullText2,
                checkbox: 1,
                is_action: 0,
                list_key: 0,
                employees: [],
                default_column: ['name', 'phone', 'email', 'jobposition', 'department', 'branch'],
                primary_key: 'employee_id',
                company_options: [],
                appended_column: [],
                selected: [],

                modification_flag: 0,

                output: '',
                download_loader: false,
                download_text: '',
                emailing_success: "",
                emailing_issue: '',
                emailing: '',
                dropdown_text: 'Choose Document',

                documents: [

                    { value: "1", text: "Income Tax Deduction Certificate" },
                    { value: "2", text: "Investment Declaration Letter" },
                    { value: "3", text: "Letter of Introduction" },
                    { value: '4', text: "Increment Letter" },
                    { value: '5', text: "Experience Certificate" },
                    { value: '6', text: "Others" },
                    { value: "7", text: "HR Policies & Handbooks" },
                    { value: '8', text: "Release Letter" },
                    { value: '9', text: "Standard Salary Certificate (Current Salary)" },
                    { value: '10', text: "Standard Salary Certificate (Period Range)" },
                    { value: '11', text: "Employment Contract" },
                    { value: '12', text: "Contract Change Letter" },
                    { value: '16', text: "Letter of Recommendation" },
                    // Afrin: Added for Template sub-category start
                    {value: '1001', text: "Acceptance of Resignation"},
                    {value: '1002', text: "Termination Letter"},
                    // Afrin: Added for Template sub-category end

                ],
                month_array: [],
                to_month_array: [],
                to_month_array_final: [],
                from_month_array: [],


            }
        },
        methods:
        {

            getFiscalYearList: function () {
                if (!this.checkNet()) return false;
                this.showoverlay = true;
                let currentObj = this;
                axios.get(this.$api_url + '/get/fiscalyear/list', {

                }).then(function (response) {
                    let fiscal_years_response = response.data;


                    let fy = [];

                    for (let i = 0; i < response.data.length; i++) {
                        fy[i] = { value: response.data[i], text: response.data[i] };
                    }

                    this.fiscal_years_salary = fy;
                    this.fiscal_years = fy;

                    this.fiscal_year = fiscal_years_response[0];
                    this.to_fiscal_year = fiscal_years_response[0];
                    this.from_fiscal_year = fiscal_years_response[0];
                    this.fiscal_year = fiscal_years_response[0];
                    this.generateMonth(this.fiscal_year);

                }.bind(this)).catch(function (error) { currentObj.showoverlay = false; currentObj.serverError(error); });
            },
            getEmployees: function () {
                if (!this.checkNet()) return false;
                this.showoverlay = true;
                let currentObj = this;
                axios.get(this.$api_url + '/employee/list', {

                }).then(function (response) {

                    this.showoverlay = false;
                    if (response.data.error == 1)
                        this.notice = response.data.notice;
                    else {
                        this.employees = response.data.employee_data;
                        this.company_options = response.data.options;
                        this.list_key = this.list_key + 1;

                    }

                }.bind(this)).catch(function (error) { currentObj.showoverlay = false; currentObj.serverError(error); });
            },

            getActiveEmployeeInRange: function (fiscal_year) {
                if (!this.checkNet()) return false;
                this.showoverlay = true;
                let currentObj = this;
                axios.get(this.$api_url + '/employee/list', {
                    params: {
                        core_hr_fiscal_year: fiscal_year
                    }

                }).then(function (response) {

                    this.showoverlay = false;
                    if (response.data.error == 1)
                        this.notice = response.data.notice;
                    else {

                        if (Array.isArray(response.data.employee_data)) {
                            this.employees = response.data.employee_data;
                        }
                        else {
                            this.employees = Object.keys(response.data.employee_data).map((key) => response.data.employee_data[key]);

                        }

                        this.company_options = response.data.options;
                        this.list_key = this.list_key + 1;

                    }

                }.bind(this)).catch(function (error) { currentObj.showoverlay = false; currentObj.serverError(error); });
            },
            listReturn: function (data) {

                if (data.selected.length > 0) {
                    this.selected = data.selected;
                }
                else {
                    this.selected = [];

                }
            },


            incomeTaxDeductionCertificate: function () {
                if (!this.checkNet()) return false;

                if (this.selected.length == 0)
                    this.$bvToast.toast("No employee selected", { title: 'Error!', variant: 'danger', solid: true, toaster: "toaster: b-toaster-top-right" });
                else {
                    let currentObj = this;
                    this.$bvToast.toast('It might take a while', {
                        title: `Info`,
                        variant: 'info',
                        solid: true
                    });
                    this.showoverlay = true;
                    let formData = new FormData();

                    formData.append('employee_ids', this.selected);
                    formData.append('fiscal_year', this.fiscal_year);
                    this.selected = [];

                    //console.log(this.fiscal_year);

                    axios.post(this.$api_url + '/incometax/deductioncertificate', formData)
                        .then(function (response) {
                            this.showoverlay = false;
                            var fileURL = response.data;

                        }.bind(this))
                        .catch(function (error) {
                            currentObj.showoverlay = false;
                            currentObj.serverError(error);
                        });
                }

            },

            downloadCertificate(flag = 0, file_only = 0) {
                if (!this.checkNet()) return false;

                if (this.selected.length == 0) {
                    this.$bvToast.toast("No employee selected. Please select employee(s)", { title: 'Error!', variant: 'danger', solid: true, toaster: "toaster: b-toaster-top-right" });
                }
                else if (this.modification_flag == 0) {
                    this.$bvToast.toast("No document selected. Please select a document", { title: 'Error!', variant: 'danger', solid: true, toaster: "toaster: b-toaster-top-right" });
                }

                else {

                    if (this.modification_flag == 10) {
                        var item = this.to_month_array_final.find(item => item.value === this.to_month);

                        if (!item) {
                            this.$bvToast.toast("Please select the Month range properly", { title: 'Error!', variant: 'danger', solid: true, toaster: "toaster: b-toaster-top-right" });

                            return 0;
                        }

                    }


                    let currentObj = this;
                    const config = {
                        headers: { 'content-type': 'multipart/form-data' }
                    }

                    let formData = new FormData();
                    formData.append('employee_ids', this.selected);
                    formData.append('fiscal_year', this.fiscal_year);
                    formData.append('modification_flag', this.modification_flag);
                    formData.append('from_month', this.from_month);
                    formData.append('to_month', this.to_month);
                    formData.append('salary_month', this.salary_month);

                    formData.append('flag', flag);
                    formData.append('file_only', file_only);

                    var modification_flag = this.modification_flag;

                    currentObj.download_loader = true;

                    if (flag == 1 && file_only == 1) {
                        currentObj.download_text = 'We are processing the files and this may take some time based on the number of employees selected.';

                        axios.post(this.$api_url + '/templates/downloadmultipletemplate', formData, config)
                            .then(function (response) {

                                if (response.data.errors) {
                                    var errors = response.data.errors;
                                    errors.replace("<br>", "</br>");
                                    currentObj.$bvToast.toast(response.data.errors, { title: 'Error!', variant: 'danger', solid: true, toaster: "toaster: b-toaster-top-right" });

                                }

                                else {
                                    currentObj.$bvToast.toast('Saved!', {
                                        title: `Success`,
                                        variant: 'success',
                                        solid: true
                                    });
                                }

                                currentObj.download_loader = false;
                                currentObj.download_text = '';
                            })
                            .catch(function (error) {
                                currentObj.output = error;
                                currentObj.download_loader = false;
                                currentObj.download_text = '';
                            });
                    }
                    else {
                        currentObj.download_text = 'We are processing your download and this may take some time based on the number of files you are downloading. Do not close this window until the download begins.';

                        axios.post(this.$api_url + '/templates/downloadmultipletemplate', formData, config)
                            .then(function (response) {

                                var fname = response.data.file_name;
                                if (response.data.download_file_name)
                                    var download_f_name = response.data.download_file_name;
                                else
                                    var download_f_name = fname;
                                if (download_f_name) {
                                    window.location.href = currentObj.$api_url + '/templates/downloadzip?file_name=' + fname + '&download_file_name=' + download_f_name + '&modification_flag=' + modification_flag;

                                    //console.log(currentObj.$api_url+'/templates/downloadzip?file_name='+fname+'&download_file_name='+download_f_name+'&modification_flag='+modification_flag);
                                }

                                if (response.data.errors) {

                                    var errors = response.data.errors;
                                    errors.replace("<br>", "</br>");
                                    currentObj.$bvToast.toast(response.data.errors, { title: 'Error!', variant: 'danger', solid: true, toaster: "toaster: b-toaster-top-right" });

                                }

                                currentObj.download_loader = false;
                                currentObj.download_text = '';
                            })
                            .catch(function (error) {
                                currentObj.output = error;
                                currentObj.download_loader = false;
                                currentObj.download_text = '';
                            });
                    }

                }
            },

            downloadAllCertificate(flag = 0, file_only = 0) {
                if (this.modification_flag == 0) {
                    this.$bvToast.toast("No document selected. Please select a document", { title: 'Error!', variant: 'danger', solid: true, toaster: "toaster: b-toaster-top-right" });
                }
                else {

                    if (this.modification_flag == 10) {
                        var item = this.to_month_array_final.find(item => item.value === this.to_month);

                        if (!item) {
                            this.$bvToast.toast("Please select the Month range properly", { title: 'Error!', variant: 'danger', solid: true, toaster: "toaster: b-toaster-top-right" });

                            return 0;
                        }

                    }

                    let currentObj = this;
                    const config = {
                        headers: { 'content-type': 'multipart/form-data' }
                    }
                    let formData = new FormData();

                    formData.append('all_certificates', 'yes');
                    formData.append('fiscal_year', this.fiscal_year);
                    formData.append('modification_flag', this.modification_flag);
                    formData.append('from_month', this.from_month);
                    formData.append('to_month', this.to_month);
                    formData.append('salary_month', this.salary_month);

                    formData.append('flag', flag);
                    formData.append('file_only', file_only);

                    var modification_flag = this.modification_flag;

                    currentObj.download_loader = true;
                    currentObj.download_text = 'We are processing your download and this may take some time based on the number of files you are downloading. Do not close this window until the download begins.';
                    axios.post(this.$api_url + '/templates/downloadmultipletemplate', formData, config)
                        .then(function (response) {
                            var fname = response.data.file_name;

                            if (response.data.download_file_name)
                                var download_f_name = response.data.download_file_name;
                            else
                                var download_f_name = fname;

                            if (download_f_name) {

                                window.location.href = currentObj.$api_url + '/templates/downloadzip?file_name=' + fname + '&download_file_name=' + download_f_name + '&modification_flag=' + modification_flag;

                            }
                            if (response.data.errors) {

                                var errors = response.data.errors;
                                currentObj.$bvToast.toast(response.data.errors, { title: 'Error!', variant: 'danger', solid: true, toaster: "toaster: b-toaster-top-right" });

                            }

                            currentObj.download_loader = false;
                            currentObj.download_text = '';
                        })
                        .catch(function (error) {
                            currentObj.output = error;
                            currentObj.download_loader = false;
                            currentObj.download_text = '';

                        });

                }

            },

            //   alpha fix- commented this
            // sendEmail(flag = 0)
            // {

            //     let currentObj = this;
            //     var msg="Are you Sure?";
            //     this.emailing_success = '';


            //     if(this.selected.length ==0){
            //         alert("Please Select employee(s).");
            //         return false;
            //     }else if(this.selected.length > 100 ){
            //         alert("You are not allowed to send more than 100 emails in one go!");
            //         return false;
            //     }else{
            //         msg="Do you want to Email the selected certificates(s)?";

            //     }
            //     if(confirm(msg)){
            //         this.emailing='1';
            //         setTimeout(() => {
            //             this.emailing='';
            //             this.emailing_issue='';


            //             const config = {
            //                 headers: { 'content-type': 'multipart/form-data' }
            //             }


            //             let formData = new FormData();
            //             formData.append('employee_ids', this.selected);
            //             formData.append('fiscal_year', this.fiscal_year);
            //             formData.append('modification_flag', this.modification_flag);
            //             formData.append('from_month', this.from_month);
            //             formData.append('to_month', this.to_month);
            //             formData.append('salary_month', this.salary_month);

            //             formData.append('flag', flag);

            //             axios.post(this.$api_url+'/templates/sendemail', formData, config)

            //             .then(function (response) {
            //                if(response.data.success)
            //                 {
            //                     currentObj.emailing_success='Email sending initiated. Receiver(s) should receive email soon. Please advise receivers to check spam / junk folder too if they complain about the emails are not being received.';

            //                     if(response.data.errors)
            //                     {
            //                         //currentObj.emailing_success='Email sending initiated. Receiver(s) should receive email soon. Please advise receivers to check spam / junk folder too if they complain about the emails are not being received.';
            //                         currentObj.emailing_issue='Some email could not be sent.';
            //                         var errors = response.data.errors;
            //                         errors.replace("<br>", "</br>");
            //                         currentObj.$bvToast.toast(response.data.errors, {title: 'Error!',variant: 'danger',solid: true, toaster: "toaster: b-toaster-top-right"});
            //                     }

            //                 }
            //                 else
            //                 {
            //                     currentObj.emailing_issue='Email sending failed';
            //                     currentObj.emailing_success='';

            //                     if(response.data.errors)
            //                     {
            //                         //currentObj.emailing_success='Email sending initiated. Receiver(s) should receive email soon. Please advise receivers to check spam / junk folder too if they complain about the emails are not being received.';
            //                         var errors = response.data.errors;
            //                         errors.replace("<br>", "</br>");
            //                         currentObj.$bvToast.toast(response.data.errors, {title: 'Error!',variant: 'danger',solid: true, toaster: "toaster: b-toaster-top-right"});
            //                     }

            //                 }



            //           })

            //           .catch(function (error) {

            //               console.log(error);

            //           });

            //         }, 5000);
            //     }


            //   },

            // alpha fix- added this
            sendEmail(flag = 0) {
                let currentObj = this;
                this.emailing_success = '';

                if (this.selected.length == 0) {
                    this.$bvModal.msgBoxConfirm('Please Select employee(s).', {
                        title: 'Please Confirm',
                        size: 'sm',
                        buttonSize: 'sm',
                        okVariant: 'primary',
                        okTitle: 'Ok',
                        footerClass: 'p-2',
                        hideHeaderClose: false,
                        centered: true
                    });
                    return false;
                } else if (this.selected.length > 100) {
                    this.$bvModal.msgBoxConfirm('You are not allowed to send more than 100 emails in one go!', {
                        title: 'Please Confirm',
                        size: 'sm',
                        buttonSize: 'sm',
                        okVariant: 'primary',
                        okTitle: 'Ok',
                        footerClass: 'p-2',
                        hideHeaderClose: false,
                        centered: true
                    });
                    return false;
                }

                this.$bvModal.msgBoxConfirm('Do you want to Email the selected certificates(s)?', {
                    title: 'Please Confirm',
                    size: 'sm',
                    buttonSize: 'sm',
                    okVariant: 'primary',
                    okTitle: 'Yes',
                    cancelTitle: 'Cancel',
                    footerClass: 'p-2',
                    hideHeaderClose: false,
                    centered: true
                }).then(value => {
                    if (value) {
                        this.emailing = '1';
                        setTimeout(() => {
                            this.emailing = '';
                            this.emailing_issue = '';

                            const config = {
                                headers: { 'content-type': 'multipart/form-data' }
                            }

                            let formData = new FormData();
                            formData.append('employee_ids', this.selected);
                            formData.append('fiscal_year', this.fiscal_year);
                            formData.append('modification_flag', this.modification_flag);
                            formData.append('from_month', this.from_month);
                            formData.append('to_month', this.to_month);
                            formData.append('salary_month', this.salary_month);
                            formData.append('flag', flag);

                            axios.post(this.$api_url + '/templates/sendemail', formData, config)
                                .then(function (response) {
                                    if (response.data.success) {
                                        currentObj.emailing_success = 'Email sending initiated. Receiver(s) should receive email soon. Please advise receivers to check spam / junk folder too if they complain about the emails are not being received.';

                                        if (response.data.errors) {
                                            currentObj.emailing_issue = 'Some email could not be sent.';
                                            var errors = response.data.errors;
                                            errors.replace("<br>", "</br>");
                                            currentObj.$bvToast.toast(response.data.errors, { title: 'Error!', variant: 'danger', solid: true, toaster: "toaster: b-toaster-top-right" });
                                        }
                                    } else {
                                        currentObj.emailing_issue = 'Email sending failed';
                                        currentObj.emailing_success = '';

                                        if (response.data.errors) {
                                            var errors = response.data.errors;
                                            errors.replace("<br>", "</br>");
                                            currentObj.$bvToast.toast(response.data.errors, { title: 'Error!', variant: 'danger', solid: true, toaster: "toaster: b-toaster-top-right" });
                                        }
                                    }
                                })
                                .catch(function (error) {
                                    console.log(error);
                                });

                        }, 5000);
                    }
                });
            },

            download_file(fileURL) {
                if (!this.checkNet()) return false;

                var fileName = fileURL.substring(fileURL.lastIndexOf('/') + 1);
                if (!window.ActiveXObject) {
                    var save = document.createElement('a');
                    save.href = fileURL;
                    save.target = '_blank';
                    //var filename = fileURL.substring(fileURL.lastIndexOf('/')+1);
                    save.download = fileName || filename;
                    if (navigator.userAgent.toLowerCase().match(/(ipad|iphone|safari)/) && navigator.userAgent.search("Chrome") < 0) {
                        document.location = save.href;
                    } else {
                        var evt = new MouseEvent('click', {
                            'view': window,
                            'bubbles': true,
                            'cancelable': false
                        });
                        save.dispatchEvent(evt);
                        (window.URL || window.webkitURL).revokeObjectURL(save.href);
                    }
                }
                else if (!!window.ActiveXObject && document.execCommand) {
                    var _window = window.open(fileURL, '_blank');
                    _window.document.close();
                    _window.document.execCommand('SaveAs', true, fileName || fileURL)
                    _window.close();
                }
            },

            setModificationFlag(x) {
                this.modification_flag = x;
                for (var i = 0; i < this.documents.length; i++) {
                    if (this.documents[i].value == x) {
                        this.dropdown_text = this.documents[i].text;

                    }
                }

            },
            generateMonth(fiscal_year) {
                var fis_year = fiscal_year;
                var all_months = [];
                const fis_array = fis_year.split("-");
                var m_names = ['January', 'February', 'March',
                    'April', 'May', 'June', 'July',
                    'August', 'September', 'October', 'November', 'December'];

                for (let i = 6; i <= 11;) {
                    var fullText = m_names[i] + '-' + fis_array[0];
                    if (i == 6) {
                        this.from_month = fullText;
                        this.to_month = fullText;
                    }


                    all_months.push({ value: fullText, text: fullText });
                    i++;
                }

                for (let i = 0; i <= 5;) {
                    var fullText = m_names[i] + '-' + fis_array[1];
                    all_months.push({ value: fullText, text: fullText });
                    i++;
                }

                this.month_array = all_months;
                this.to_month_array = all_months;
                this.from_month_array = all_months;
                this.to_month_array_final = all_months;



            }
        },
        created() {


            this.getFiscalYearList();
            this.getEmployees();



        },
        computed:
        {

            sendFiscalYear() {
                if (this.modification_flag == 1) {
                    this.common_list_fiscal_year = this.fiscal_year;
                    this.getActiveEmployeeInRange(this.common_list_fiscal_year);
                }
                else {
                    this.getEmployees();
                }

            },
            regenerateMonths() {

                var m_names = ['January', 'February', 'March',
                    'April', 'May', 'June', 'July',
                    'August', 'September', 'October', 'November', 'December'];


                if (this.to_month_array.length > 0) {


                    var item = this.to_month_array.find(item => item.value === this.from_month);


                    //console.log(item);

                    if (item.text) {
                        var from_mnth = item.text;
                        const str_month_arr_2 = from_mnth.split("-");
                        var f_year = parseInt(str_month_arr_2[1]);
                        var f_month = str_month_arr_2[0];
                        var f_month_final = m_names.indexOf(f_month);
                        var dt1 = 1;
                        const from_date = new Date(f_year, f_month_final, dt1);

                        var to_mon_array = [];

                        for (let i = 0; i <= 11;) {

                            const str_month_arr_3 = this.to_month_array[i].text.split("-");
                            var f_year_1 = parseInt(str_month_arr_3[1]);
                            var f_month_1 = str_month_arr_3[0];
                            var f_month_final_1 = m_names.indexOf(f_month_1);
                            var dt1 = 1;
                            const to_date = new Date(f_year_1, f_month_final_1, dt1);

                            if (to_date.getTime() >= from_date.getTime()) {
                                var fullText = m_names[to_date.getMonth()] + '-' + to_date.getFullYear();
                                to_mon_array.push({ value: fullText, text: fullText });
                            }


                            i++;
                        }

                        this.to_month_array_final = to_mon_array;


                    }
                }

            }
        }
    };
</script>
